import React, { useState, useEffect } from "react";
import {
  AcmeCoOperationErrorIcon,
  NewNotificationIcon,
  ThreeDots,
} from "../../assets/icons";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { reqToUpdateSettings } from "../../redux/slices.js/settings/settingsSlice";

const APIConfiguration = ({ apiKeys = [], settings = [] }) => {
  const dispatch = useDispatch();
  // Convert settings array → object { name: value }
  const initialState = settings.reduce((acc, s) => {
    acc[s.name] = s.value;
    return acc;
  }, {});

  const [formValues, setFormValues] = useState({
    api_rate_limit_requests: "",
    rate_limit_window_seconds: "",
    webhook_retry_attempts: "",
    webhook_timeout_seconds: "",
    ...initialState, // override defaults with actual settings
  });

  const handleChange = (field, value) => {
    setFormValues((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSaveChanges = () => {
    const payload = Object.entries(formValues).map(([name, value]) => ({
      name,
      value: value instanceof Date ? value.toISOString() : value,
    }));

    dispatch(
      reqToUpdateSettings({
        data: payload,
        onSuccess: (response) => {
          // any additional success logic here
        },
        onFailure: (error) => {
          console.error("Failed to update settings:", error);
          // any additional failure logic here
        },
      })
    );
  };

  return (
    <>
      <div className="space-y-4">
        <div className="bg-[#EDF7FF] rounded-xl sm:p-6 p-3">
          <div className="flex flex-col xl:flex-row md:items-start gap-4 md:justify-between">
            <div className="flex items-center gap-2">
              <span className="min-[40px]">{AcmeCoOperationErrorIcon}</span>
              <div>
                <span className="text-[16px] font-semibold mb-2 block">
                  API Keys
                </span>
                <p className="text-[16px] text-gray-500 text-sm mb-0">
                  Manage API keys for external integrations
                </p>
              </div>
            </div>
            <div className="mt-4 md:mt-0 flex gap-2 flex-col sm:flex-row">
              <button className="whitespace-nowrap btn-light-blue w-full !gap-2">
                {NewNotificationIcon}Generate New API Keys
              </button>
            </div>
          </div>
        </div>

        <div className="w-full overflow-auto mt-4 rounded-lg max-h-[300px] common-scroll">
          <table className="min-w-[500px] w-full table-auto">
            <thead>
              <tr>
                <th>Name</th>
                <th>Key</th>
                <th>Created</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {apiKeys.map((item) => (
                <tr key={item.id}>
                  <td>{item.name}</td>
                  <td className="!font-normal">{item.key}</td>
                  <td className="!font-normal">{item.created}</td>
                  <td>
                    <span className="px-2 py-1 min-w-[57px] inline-block text-center rounded-full text-body bg-[#F6FFEC] text-[#328708]">
                      {item.status}
                    </span>
                  </td>
                  <td>{ThreeDots}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="grid gap-4 md:gap-6 md:grid-cols-2">
          <div className="form-group">
            <label>
              API Rate Limit (requests) <span>*</span>
            </label>
            <input
              type="number"
              placeholder="1000"
              value={formValues.api_rate_limit_requests}
              onChange={(e) =>
                handleChange("api_rate_limit_requests", e.target.value)
              }
            />
          </div>
          <div className="form-group">
            <label>
              Rate Limit Window (seconds) <span>*</span>
            </label>
            <input
              type="number"
              placeholder="60"
              value={formValues.rate_limit_window_seconds}
              onChange={(e) =>
                handleChange("rate_limit_window_seconds", e.target.value)
              }
            />
          </div>
          <div className="form-group">
            <label>
              Webhook Retry Attempts <span>*</span>
            </label>
            <input
              type="number"
              placeholder="1000"
              value={formValues.webhook_retry_attempts}
              onChange={(e) =>
                handleChange("webhook_retry_attempts", e.target.value)
              }
            />
          </div>
          <div className="form-group">
            <label>
              Webhook Timeout (seconds) <span>*</span>
            </label>
            <input
              type="number"
              placeholder="60"
              value={formValues.webhook_timeout_seconds}
              onChange={(e) =>
                handleChange("webhook_timeout_seconds", e.target.value)
              }
            />
          </div>
        </div>
      </div>

      <div className={`mt-auto flex gap-3 pt-6 justify-end flex-wrap`}>
        <button type="button" className="next-btn" onClick={handleSaveChanges}>
          Save API Settings
        </button>
      </div>
    </>
  );
};

export default APIConfiguration;
